import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITamIntervenant } from '../model/tam-intervenant.model';
import { convertToHumanDate } from '../util/moment.utils';
import { TableDonneeDeclarerDDCSEnum } from '../constant/enum';
import { Sort } from '@angular/material/sort';

@Component({
    selector: 'ddc-donnees-declaration-tam',
    templateUrl: './donnees-declaration-tam.component.html',
    styleUrls: ['./donnees-declaration-tam.component.scss'],
    standalone: false
})
export class DonneesDeclarationTamComponent {

  @Input() set donneesDeclarationTam(donneesDeclarationTam: IDonneesDeclarationTam) {
    this._donneesDeclarationTam = donneesDeclarationTam;
  }

  @Input() set donneesDeclarationTamToDo(donneesDeclarationTam: IDonneesDeclarationTam) {
    this._donneesDeclarationTamToDo = donneesDeclarationTam;
  }

  @Input() set blockTitleLabelKey(blockTitleLabelKey: string) {
    this._blockTitleLabelKey = blockTitleLabelKey;
  }

  @Input() set blockDescriptionLabelKey(blockDescriptionLabelKey: string) {
    this._blockDescriptionLabelKey = blockDescriptionLabelKey;
  }

  @Input() set isLoading(isLoading: boolean) {
    this._isLoading = isLoading;
  }

  @Input() set donneesDeclarationTamTotals(donneesDeclarationTamTotals: IDonneesDeclarationTamTotals[]) {
      this._donneesDeclarationTamTotals = donneesDeclarationTamTotals;
  }

  @Output() loadDonneesDeclarationTam = new EventEmitter<any>();

  sortActive: string = 'prenom';
  sortDirection: string = 'desc';
  public _isLoading: boolean = false;
  public isDataBlockDisplayed: boolean = false;
  public _donneesDeclarationTam: IDonneesDeclarationTam;
  public _donneesDeclarationTamToDo: IDonneesDeclarationTam;
  public _blockTitleLabelKey: string;
  public _blockDescriptionLabelKey: string;
  public _donneesDeclarationTamTotals: IDonneesDeclarationTamTotals[];
  public _donneesDeclarationTamTotalsColumns: string[] = ['totalDirecteurs', 'totalAdjoints', 'totalAnimateurs', 'totalAutres', 'totalTitulaires', 'totalStagiaires', 'totalNonQualifies'];
  convertToHumanDate = convertToHumanDate;
  TableDonneeDeclarerDDCSEnum = TableDonneeDeclarerDDCSEnum;

  constructor() {
    // Do nothing for the moment
  }

  displayDataToDeclare(): void {
    this.isDataBlockDisplayed = !this.isDataBlockDisplayed;
    this.loadDonneesDeclarationTam.emit();
  }

  sortData(sort: Sort, sortedData) {
    if(sortedData == TableDonneeDeclarerDDCSEnum.INTERVENANT){
      const data = this._donneesDeclarationTam.intervenants.slice();
      if (!sort.active || sort.direction === '') {
        this._donneesDeclarationTam.intervenants = data;
        return;
      }
      this._donneesDeclarationTam.intervenants = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        return this.compare(a[sort.active], b[sort.active], isAsc);
      });
    }
    else if(sortedData == TableDonneeDeclarerDDCSEnum.LIEUX){
      const data = this._donneesDeclarationTam.lieux.slice();
      if (!sort.active || sort.direction === '') {
        this._donneesDeclarationTam.lieux = data;
        return;
      }
      this._donneesDeclarationTam.lieux = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        return this.compare(a[sort.active], b[sort.active], isAsc);
      });
    }
    else if(sortedData == TableDonneeDeclarerDDCSEnum.INTERVENANT_TO_DO){
      const data = this._donneesDeclarationTamToDo.intervenants.slice();
      if (!sort.active || sort.direction === '') {
        this._donneesDeclarationTamToDo.intervenants = data;
        return;
      }
      this._donneesDeclarationTamToDo.intervenants = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        return this.compare(a[sort.active], b[sort.active], isAsc);
      });
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }




}

export interface IDonneesDeclarationTam {
  informationsGenerales?: IInformationGenerales[][];

  intervenants?: object[];
  intervenantLabelKeys?: object;
  intervenantsTableDisplayedColumns?: string[];

  adherentResponsable?: ITamIntervenant;
  adherentDeclarant?: ITamIntervenant;

  lieux?: object[];
  lieuLabelKeys?: object;
  lieuxTableDisplayedColumns?: string[];
}

export interface IInformationGenerales {
  class?: string;
  labelKey?: string;
  value?: any;
}

export interface IDonneesDeclarationTamTotals {
    totalDirecteurs?: number;
    totalAdjoints?: number;
    totalAnimateurs?: number;
    totalAutres?: number;
    totalTitulaires?: number;
    totalStagiaires?: number;
    totalNonQualifies?: number;
    totalAdherents?: number;
}
